module.exports = __webpack_public_path__ + "static/media/eligible_delete.0a470555.svg";